import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = null;

export const panchangUpdate = createSlice({
    name: "panchangUpdate",
    initialState: {
        value: initialStateValue,
    },
    reducers: {
        setPanchangUpdateReducer: (state, action) => {
            state.value = action.payload;
        },
        clearPanchangUpdateReducer: (state) => {
            state.value = initialStateValue;
        },
    },
});
export const { setPanchangUpdateReducer, clearPanchangUpdateReducer } = panchangUpdate.actions;
export default panchangUpdate.reducer;